import { Box, ThemeProvider } from '@mui/material';
import { BoxProps } from '@mui/material/Box/Box';
import { useMemo } from 'react';

import { useSxStyles } from '~/components/Sidebar/useStyles';
import { useAppearance } from '~/data/appearance';
import { LoadingView } from '~/scenes/PortalViews/components/LoadingView';
import { createSolaForceTheme } from '~/theme';
import { mergeSxProps } from '~/utils/helpers/sxProps';

export const Sidebar = (props: BoxProps) => {
  const { children, sx, ...rest } = props;

  const sxStyles = useSxStyles();
  const { customAppearance, isLoading, hasData } = useAppearance();

  const { sidebarTheme, backgroundColor } = useMemo(() => {
    const actionColor = customAppearance?.fLeftSideMenuColors?.fIconsColor;
    const backgroundColor =
      customAppearance?.fLeftSideMenuColors?.fBackgroundColor ?? '#eee';

    const isThemeDark = (hexColor?: string) => {
      if (!hexColor || !hexColor.startsWith('#')) {
        return false;
      }

      var r = parseInt(hexColor.substring(1, 3), 16);
      var g = parseInt(hexColor.substring(3, 5), 16);
      var b = parseInt(hexColor.substring(5, 7), 16);
      var yiq = (r * 299 + g * 587 + b * 114) / 1000;

      return !(yiq >= 128);
    };

    return {
      sidebarTheme: createSolaForceTheme({
        primaryColor: actionColor,
        isDarkTheme: isThemeDark(backgroundColor),
      }),
      backgroundColor,
    };
  }, [customAppearance]);

  if (isLoading || !hasData) {
    return <LoadingView />;
  }

  return (
    <ThemeProvider theme={sidebarTheme}>
      <Box
        {...rest}
        sx={mergeSxProps(sxStyles.root, sx, {
          backgroundColor,
          color: sidebarTheme.palette.text.primary,
        })}
      >
        {children}
      </Box>
    </ThemeProvider>
  );
};
